import { render, staticRenderFns } from "./EntesitisBodyModel.vue?vue&type=template&id=2ac5e07d&scoped=true&"
import script from "./EntesitisBodyModel.vue?vue&type=script&lang=js&"
export * from "./EntesitisBodyModel.vue?vue&type=script&lang=js&"
import style0 from "./EntesitisBodyModel.vue?vue&type=style&index=0&id=2ac5e07d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5e07d",
  null
  
)

export default component.exports